import React from 'react';

import { Footer } from '@consumer-frontend/shared-ui';

import { DisclaimerText } from './DisclaimerText';
import { Links } from './Links';
import { SocialTrustedSite } from './SocialTrustedSite';

import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/footer.scss';

export const CnuFooter: React.FC = () => {
  return (
    <Footer className="d-inline-block flex-column">
      <div className="footer-container">
        <SocialTrustedSite />
        <Links />
        <DisclaimerText />
      </div>
    </Footer>
  );
};
